// extracted by mini-css-extract-plugin
export default {"RentalCompany":"Welcome_RentalCompany__dgh02","StoreLogo":"Welcome_StoreLogo__3fw0S","NextLink":"Welcome_NextLink__sktIr"};